import { API, ApiResponseBase, CustomAxiosError } from "../../../../../logics/api-config";
import { useQuery, UseQueryResult } from "react-query";
import {IRestaurant} from "../../../../../utils/interfaces/Accounting/Recap/IRestaurant";

export interface ApiResponse extends ApiResponseBase {
    data: IRestaurant[];
}

async function doGet(): Promise<IRestaurant[]> {
    const response = await API.get(`/accounting/billing-data/restaurants-list`);
    return response?.data;
}

const useApiGetListRestaurants = (
    options: any = {}
): UseQueryResult<IRestaurant[], CustomAxiosError> => {
    return useQuery<IRestaurant[], CustomAxiosError>(
        ["getListRestaurants"],
        () => doGet(),
        { ...options }
    );
};

export default useApiGetListRestaurants;